import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EndPointService } from './end-point.service';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class ConfigService extends EndPointService {
  constructor(http: HttpClient) {
    super(http);
  }

  public getConfig(): Observable<any> {
    return this.getOrAdd<any, any>(
      `./assets/config/configMap/config.json?id=${uuidv4()}`
    ).pipe(
      map((urls) => {
        return urls;
      })
    );
  }

  public getMessages(): Observable<any> {
    return this.getOrAdd<any, any>(
      `./assets/config/configMap/messages.json?id=${uuidv4()}`
    );
  }
}
